export default __webpack_public_path__ + "static/GT-America-Standard-Regular-1776b7c453df8e5bb21021e43524eca5.eot";